import {
  Box,
  Flex,
  HStack,
  Stack,
  Text,
  Image,
  StackDivider,
  Button,
} from "@chakra-ui/react";
import React from "react";
import CommonContainer from "../components/shared/CommonContainer";
import { BiChevronRight } from "react-icons/bi";
import { BsArrowLeft, BsStarFill } from "react-icons/bs";
import ConnectWalletPopup from "../components/checkout/ConnectWalletPopup";

export default function CheckoutPage() {
  return (
    <CommonContainer>
      <HStack
        sx={{ fontWeight: 500 }}
        alignItems="center"
        py={6}
        fontWeight="semibold"
      >
        <Text color="brand.500">Order Details</Text>
        <BiChevronRight />
        <Text>Connect Wallet</Text>
        <BiChevronRight />
        <Text>Pay Now</Text>
      </HStack>
      <Flex gap={{ lg: 10 }} mb={10} flexDir={{ base: "column", lg: "row" }}>
        <Box w={{ xl: "70%" }}>
          <Flex
            borderRadius={10}
            color="brand.400"
            p={{ base: 4, lg: 10 }}
            bg="#f7f7f7"
            alignItems={{ xl: "center" }}
            justifyContent="space-between"
            flexDir={{ base: "column", xl: "row" }}
          >
            <HStack
              gap={{ base: 6, lg: 2 }}
              flexDir={{ base: "column", lg: "row" }}
              alignItems="start"
            >
              <Image
                src="/images/marketplace-category/logo/logo-1.png"
                maxW={{ lg: "210px" }}
              />
              <Stack>
                <Text
                  color="#747474"
                  fontSize={{ base: "18px", lg: "21px" }}
                  maxW="360px"
                  fontWeight={"semibold"}
                >
                  I will design 3 modern minimalist logo design
                </Text>
                <Flex
                  color={"#ffbe5b"}
                  gap={1}
                  alignItems="center"
                  fontWeight="semibold"
                >
                  <BsStarFill />
                  <BsStarFill />
                  <BsStarFill />
                  <BsStarFill />
                  <BsStarFill />
                  <Text>5</Text>
                  <Text color="#888" pl={2}>
                    (2000 reviews)
                  </Text>
                </Flex>
              </Stack>
            </HStack>
            <Box py={{ base: 4, xl: 0 }}>
              <Button
                leftIcon={<BsArrowLeft />}
                bg={"brand.500"}
                color="white"
                fontSize={{ base: "11px", lg: "16px" }}
              >
                Select Another Package
              </Button>
            </Box>
          </Flex>
          <Stack
            sx={{
              fontWeight: "semibold",
              fontSize: { base: "12px", md: "16px" },
            }}
            p={{ base: 6, lg: 10 }}
            my={8}
            border="1px"
            borderColor="gray.200"
            borderRadius={10}
          >
            <Text fontSize={{ base: "16px", md: "20px" }}>
              Upgrade your order with extras
            </Text>
            <HStack
              justifyContent="space-between"
              py={4}
              borderBottom="1px"
              borderColor="gray.200"
            >
              <Text color="#727272">Extra fast 1 Day Delivery</Text>
              <Text>US$60</Text>
            </HStack>
            <HStack
              justifyContent="space-between"
              py={4}
              borderBottom="1px"
              borderColor="gray.200"
            >
              <Text color="#727272">Include Source File</Text>
              <Text>US$120</Text>
            </HStack>
            <HStack
              justifyContent="space-between"
              py={4}
              borderBottom="1px"
              borderColor="gray.200"
            >
              <Text color="#727272">Stationery Design</Text>
              <Text>US$200</Text>
            </HStack>
            <HStack
              justifyContent="space-between"
              py={4}
              borderBottom="1px"
              borderColor="gray.200"
            >
              <Text color="#727272">Include Source File</Text>
              <Text>US$120</Text>
            </HStack>
            <HStack justifyContent="space-between" py={4}>
              <Text color="#727272">Include Source File</Text>
              <Text>US$120</Text>
            </HStack>
          </Stack>
        </Box>
        <Stack
          w={{ xl: "25%" }}
          bg="#f7f7f7"
          p={8}
          fontSize={{ base: "13px", md: "20px" }}
          sx={{ fontWeight: "semibold" }}
        >
          <Text fontSize={{ md: "23px" }}>Price Summary</Text>
          <HStack justifyContent="space-between" py={4}>
            <Text color="#727272">Subtotal</Text>
            <Text>US$60</Text>
          </HStack>
          <HStack
            justifyContent="space-between"
            pb={4}
            borderBottom="1px"
            borderColor="gray.200"
          >
            <Text color="#727272">Service Fee</Text>
            <Text>US$60</Text>
          </HStack>
          <StackDivider height="2px" />
          <HStack justifyContent="space-between" pb={4}>
            <Text>Total</Text>
            <Text>US$60</Text>
          </HStack>
          <HStack justifyContent="space-between" pb={8} color="#727272">
            <Text>Delivery Time</Text>
            <Text>3 days</Text>
          </HStack>
          <ConnectWalletPopup />
        </Stack>
      </Flex>
    </CommonContainer>
  );
}
